import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import { get } from 'lodash';
import React from 'react';
import { OriCheckbox, OriSelect, Select } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  ResponsiveAnimation,
  ResponsiveModuleStyle,
  ResponsiveText,
} from 'src/components/Modules/Components';
import { moduleStyleProps } from 'src/components/Modules/Components/ModuleStyle/tools';
import Switcher from 'src/components/SectionSwitcher';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import {
  EModuleWidth,
  EOverflowOption,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveProductToShow,
} from 'src/types/common/module';
import css from './css.module.less';
const Option = OriSelect.Option;

const ResponsiveProductGrid = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visible, setVisible] = React.useState(false);
  //console.log(props);
  const {
    onItemReselect,
    onItemDelete,
    onItemSort,
    onStaticChange,
    products,
    specificError,
    staticData,
    breakpoint,
    animations,
    hoverAnimations,
    buttons,
  } = props;
  const isConvertible = breakpoint !== EPreviewSize.WIDE;
  const isMobile = breakpoint === EPreviewSize.MOBILE;
  const productToShowError = get(specificError, 'productToShowError') || [];
  const productToShowMismatchError =
    get(specificError, 'productToShowMismatchError') || [];

  const draggableId = get(staticData, 'draggableId');
  const moduleWidth = get(staticData, 'moduleWidth');
  const productToShow = get(staticData, 'productToShow');
  const leaveGap = get(staticData, 'leaveGap');
  const actionButtonTheme = get(staticData, 'actionButtonTheme') || null;
  const overflowOption = get(staticData, 'overflowOption');

  const animation = get(staticData, 'animation');
  const moduleStyle = get(staticData, 'moduleStyle');

  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;
  const text = get(staticData, 'moduleText');
  const handleOnActionButtonThemeChange = (actionButtonTheme) => {
    onStaticChange({ actionButtonTheme });
  };

  const isOneProductOnScreen = productToShow === EResponsiveProductToShow.One;

  //console.log('moduleWidth', moduleWidth);

  const handleOnLeaveGapChange = (e) => {
    const leaveGap = e.target.checked;
    onStaticChange({ leaveGap });
  };

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnProductToShowChange = (productToShow) => {
    onStaticChange({ productToShow });

    // onStaticChange({ productToShow });
  };

  const handleOnOverflowOptionChange = (overflowOption) => {
    onStaticChange({ overflowOption });
  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  const handleTextChange = (ani) => {
    const newText = { ...(text || {}), ...ani };
    onStaticChange({ moduleText: newText });
  };

  const handleOnItemReselect = (products) => {
    if (onItemReselect) {
      const _products = products.map((i) => {
        return { ...i, draggableId: i.uuid };
      });
      // console.log('_products', _products);
      //const item = generateResponsiveImage();
      //console.log('item', item);
      onItemReselect(_products);
    }
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onItemSort(oldIndex, newIndex);
  };

  const handleOnItemDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const childGenerate = (data, index) => {
    const sku = get(data, 'sku');
    const name = get(data, 'productName');
    const thumbnailUrl = get(data, 'thumbnailUrl');
    return <ProductDisplayInRow sku={sku} name={name} img={thumbnailUrl} />;
  };

  const renderProductToShow = () => {
    return [
      <Option
        value={EResponsiveProductToShow.One}
        key={EResponsiveProductToShow.One}>
        One Product In A Row
      </Option>,
      ...(isMobile
        ? [
            <Option
              value={EResponsiveProductToShow.Two}
              key={EResponsiveProductToShow.Two}>
              Two Products In A Row
            </Option>,
            <Option
              value={EResponsiveProductToShow.Three}
              key={EResponsiveProductToShow.Three}>
              Three Products In A Row
            </Option>,
          ]
        : [
            <Option
              value={EResponsiveProductToShow.TwoLandscape}
              key={EResponsiveProductToShow.TwoLandscape}>
              Two Products In A Row (Landscape)
            </Option>,
            <Option
              value={EResponsiveProductToShow.TwoPortrait}
              key={EResponsiveProductToShow.TwoPortrait}>
              Two Products In A Row (Portrait)
            </Option>,
            <Option
              value={EResponsiveProductToShow.Three}
              key={EResponsiveProductToShow.Three}>
              Three Products In A Row
            </Option>,
          ]),

      ...(isConvertible
        ? []
        : [
            <Option
              value={EResponsiveProductToShow.Four}
              key={EResponsiveProductToShow.Four}>
              Four Products In A Row
            </Option>,
            <Option
              value={EResponsiveProductToShow.Five}
              key={EResponsiveProductToShow.Five}>
              Five Products In A Row
            </Option>,
            <Option
              value={EResponsiveProductToShow.Six}
              key={EResponsiveProductToShow.Six}>
              Six Products In A Row
            </Option>,
          ]),
    ];
  };

  return (
    <React.Fragment>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={() => {
            setVisible(false);
          }}
          onOk={handleOnItemReselect}
          selectedProducts={products || []}
          disabledProducts={[]}
        />
      )}
      {!isConvertible && (
        <Section size='small' bottomBorder className={css.container}>
          <ItemWrapper title={getI18n('general.moduleWidth')}>
            <OriSelect
              size='large'
              value={moduleWidth}
              onChange={handleOnModuleWidthChange}>
              <Option value={EModuleWidth.WIDE}>
                {getI18n('general.wideWidth')}
              </Option>
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            </OriSelect>
          </ItemWrapper>
        </Section>
      )}

      <Section size='small' bottomBorder>
        <ItemWrapper title='Product In A Row'>
          <Select
            error={productToShowError.length > 0}
            help={productToShowError.join(' ')}
            size='large'
            value={productToShow}
            onChange={handleOnProductToShowChange}>
            {renderProductToShow()}
          </Select>
        </ItemWrapper>
        {!isOneProductOnScreen && (
          <React.Fragment>
            <div className={css.gapContainer}>
              <OriCheckbox checked={leaveGap} onChange={handleOnLeaveGapChange}>
                Leave gap between products
              </OriCheckbox>
            </div>
          </React.Fragment>
        )}

        <ItemWrapper title='Call To Action Button Theme(Optional)'>
          <OriSelect
            size='large'
            value={actionButtonTheme}
            onChange={handleOnActionButtonThemeChange}>
            <OriSelect.Option value={null}>None</OriSelect.Option>
            {(buttons || []).map((i) => {
              return (
                <OriSelect.Option value={i.uuid} key={i.uuid}>
                  {i.name}
                </OriSelect.Option>
              );
            })}
          </OriSelect>
        </ItemWrapper>
      </Section>
      {isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper title='Overflow Items Display Option'>
            <OriSelect
              size='large'
              value={overflowOption}
              onChange={handleOnOverflowOptionChange}>
              <OriSelect.Option value={EOverflowOption.Carousel}>
                Convert To Carousel
              </OriSelect.Option>
              <OriSelect.Option value={EOverflowOption.AnotherLine}>
                Shift To Another Line
              </OriSelect.Option>
              <OriSelect.Option value={EOverflowOption.Hide}>
                Hide
              </OriSelect.Option>
            </OriSelect>
          </ItemWrapper>
        </Section>
      )}
      <Section size='small' className={css.switcherContainer}>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ResponsiveModuleStyle
                    {...moduleStyleProps(moduleWidth)}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                    isMobileOrTablet={isConvertible}
                  />
                </div>
              ),
            },
            ...(isConvertible
              ? {}
              : {
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.Text]: {
                    title: getI18n('general.text'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveText
                          data={text}
                          onChange={handleTextChange}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.Products]: {
                    title: 'Products',
                    hasError: productToShowMismatchError.length > 0,
                    child: (
                      <DragNDropColumns
                        // disabled={!isPrimary}
                        // hideAdd={!isPrimary}
                        hideTitle
                        childGenerate={childGenerate}
                        data={products}
                        droppableId={`salesChannelContentListProductGrid${draggableId}`}
                        onSort={handleItemOnSort}
                        // hideAdd={hideAdd}
                        onAdd={() => {
                          setVisible(true);
                        }}
                        addText={'+ Add Product'}
                        onDelete={handleOnItemDelete}
                      />
                    ),
                  },
                }),
          }}
        />
      </Section>
    </React.Fragment>
  );
};
export default ResponsiveProductGrid;
